import { FC } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { Drawer, Text, Divider, Box } from '@mantine/core';
import { creatorActions } from '@/store/slices/creatorSlice';
import { RichText } from '@/components/ui/richText/RichText';

export const CreatorHelpDrawer: FC = () => {
	const dispatch = useTypedDispatch();

	const { options } = useTypedSelector((state) => state.creator);

	const handleClose = () => {
		dispatch(creatorActions.updateOptions({ helpDrawerOpened: false }));
	};

	return (
		<Drawer
			opened={options.helpDrawerOpened}
			onClose={handleClose}
			title={
				<>
					<Text size="md" mb="xs">
						Więcej informacji o produkcie
					</Text>
					<Text size="xl" fw="bold">
						{options.helpDrawerData?.title}
					</Text>
				</>
			}
		>
			<Box>
				<Divider size="md" my="sm" />
				<RichText raw={options.helpDrawerData?.description || ''} />
			</Box>
		</Drawer>
	);
};
